import _Api from "../playmore/api"
import axios from "axios"

class Api extends _Api {
  constructor() {
    super()
  }
  async _init() {
    _$.vue.$once("platformInit", () => this.setServerConfiguration())
    return super._init()
  }

  addListeners() {
    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", () => window.location.reload())
    _$.vue.$on("powerOn", () => __.media.request())

    return super.addListeners()
  }
  async makeConfigurations() {
    return super.makeConfigurations()
  }
  async loadResources() {
    return super.loadResources()
  }
  async getProperties() {
    return super.getProperties()
  }
  async setServerConfiguration() {
    const config = await axios
      .get(`${__.platform.baseUrl}/Api/philips/config.json`)
      .then(response => response.data)
      .catch(() => false)
    if (!config) throw "An error occured while getting Philips config from server"

    if (config.active) playmore.device.setServerSettings(config.appControlID, config.profileName, config.locationID)
    playmore.device.setWebServerURL(`${__.platform.baseUrl}/Api/philips/listener.php`)
    return true
  }
  checkIn() {
    const { ip } = __.device.properties
    return axios
      .post(`${__.platform.baseUrl}/Api/philips/pms.php`, {
        Action: "CheckIn",
        IpAddress: ip
      })
      .then(res => {
        setTimeout(async () => {
          __.app.availableApps = await __._app.getList()
          if (!__.app.availableApps) __.app.availableApps = []
        }, 10000)

        return res.data
      })
      .catch(() => _$.error("An error occured while checkIn"))
  }
  checkOut() {
    const { ip } = __.device.properties
    return axios
      .post(`${__.platform.baseUrl}/Api/philips/pms.php`, {
        Action: "CheckOut",
        IpAddress: ip
      })
      .then(res => res.data)
      .catch(() => _$.error("An error occured while checkOut"))
  }
}

export default Api
